import { memo, useEffect, useState } from 'react';
import { Card, CardContent, Grid, Box, Button, IconButton, Chip, TextField, FormControl, Typography, MenuItem } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTMutation } from '../../../../../utils/useTMutation';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTQuery } from '../../../../../utils/useTQuery';
// import { previousStep, update } from '../../../../../slice/multiStepSlice';
// import { nextStep } from '../../../../../slice/onBoardWizardSlice';
import { customStep, nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

// Define schema for form validation
export const roleSchema = z.object({
    CERTIFICATE_ID: z.array(z.string()).min(1, { message: "At least one Certificate must be selected" }),
});

const AssignCertificate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    console.log("values", values);
    const [certificates, setCertificates] = useState([]);
    const [selectedCertificates, setSelectedCertificates] = useState([]);

    const { data: certificateData } = useTQuery(
        "speciality_Certificate",
        "/fetchAllCertificates",
        "post"
    );
    console.log("certificateData", certificateData);
    useEffect(() => {
        if (certificateData?.STATUS) {
            setCertificates(certificateData.OUTPUT);
        }
    }, [certificateData]);
    useEffect(() => {
        if (values.CERTIFICATE_ID) setSelectedCertificates(values.CERTIFICATE_ID);
    }, [values])
    const {
        control,
        handleSubmit,
        register,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: { CERTIFICATE_ID: values?.CERTIFICATE_ID || [] },
    });

    const { mutateAsync } = useTMutation("/addUpdateSpecialty", "post", (response) => {
        return response
    });

    const submitJobRole = async (formData) => {
        console.log("Job Datadfsgdfg", formData)

        try {
            const response = await mutateAsync({
                ...formData,
                ID: values?.ID
            });

            if (response.STATUS) {

                console.log("sRolea", formData?.CERTIFICATE_ID)
                dispatch(update({ CERTIFICATE_ID: formData?.CERTIFICATE_ID }))

                dispatch(nextStep())
                showToast("success", response.MESSAGE, 3000);
                navigate("/admin/profile-criteria/fetchSpecialtyRoleMappings")
            } else {
                showToast("error", response.MESSAGE, 3000);
            }

        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (roleId) => {
        setSelectedCertificates((prev) => prev.filter(id => id !== roleId));
        setValue('CERTIFICATE_ID', selectedCertificates.filter(id => id !== roleId));
        clearErrors('CERTIFICATE_ID');
    };

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        console.log("selectedRoleId", selectedRoleId)
        if (selectedRoleId && !selectedCertificates.includes(selectedRoleId)) {
            const updatedRoles = [...selectedCertificates, selectedRoleId];
            setSelectedCertificates(updatedRoles);
            setValue('CERTIFICATE_ID', updatedRoles);
        }
    };
    console.log("asdasd", certificates, values)

    return (
        <>
            {!values.REDIRECT && <Button
                onClick={() => dispatch(customStep(2))}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
            >
            </Button>}
            <Grid lg={12} p={4}>





                <CardContent>
                    <Typography variant="h2" component="div" mb={4} fontWeight="bold">
                        Assign certificates
                    </Typography>
                    <form onSubmit={handleSubmit(submitJobRole)}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <FormControl fullWidth margin="normal">
                                <Controller
                                    name="CERTIFICATE_ID"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            label="Certificates"
                                            value=""
                                            onChange={handleRoleChange}
                                            error={!!errors.CERTIFICATE_ID}
                                            helperText={errors.CERTIFICATE_ID?.message}
                                        >
                                            <MenuItem disabled value="">Select</MenuItem>
                                            {certificates.map((certificate) => (
                                                <MenuItem key={certificate.ID} value={certificate.ID}>
                                                    {certificate.certificateName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                                {errors.CERTIFICATE_ID && <Typography color="error">{errors.CERTIFICATE_ID.message}</Typography>}
                            </FormControl>

                            <Box sx={{ mt: 2 }}>
                                <Grid container spacing={1}>
                                    {selectedCertificates.map((roleId) => (
                                        <Grid item xs={4} key={roleId}>
                                            <Chip
                                                label={certificates.find(role => role.ID === roleId)?.certificateName}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    className='gradientAdminThemeColor'
                                    // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                    type='submit'>
                                    Add
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </CardContent>





            </Grid>

        </>
    );
};

export default memo(AssignCertificate);
